<template>
  <div class="step_bar w-row">
    <div v-for="step in getMotorSteps" :key="step.ID" class="w-col w-col-3">
      <a href="javascript:;" :class="['step_link w-inline-block w-clearfix', step.SUBSTEPS.includes(getMotorOfferStep) ? 'active' : '']" @click="goToStep(step)">
        <h6 class="step_header">{{$t(step.DESC)}}</h6>
        <div class="step_bullet"></div>
        <div class="step_line"></div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('motor', ['getMotorSteps', 'getMotorOfferStep']),
  },
  methods: {
    ...mapActions('motor', ['setMotorOfferStepAction']),
    goToStep(step) {
      if (this.$route.name !== 'MotorOffer') return;
      if (!step.ACTIVATED) return;
      this.setMotorOfferStepAction(step.SUBSTEPS[0]);
    }
  },
};
</script>
